<script>
  import AdminPageLayout from "../../../components/layout/pageLayouts/admin/AdminPageLayout.svelte";
  import { translate } from "../../../i18n/i18next.js";
  import Sections from "../../../components/layout/Sections.svelte";
  import TopSection from "./TopSection.svelte";
  import LicenseSection from "./LicenseSection.svelte";
</script>

<AdminPageLayout title={translate("frontend:pages.admin.server.title")}>
  <Sections>
    <TopSection />
    <LicenseSection />
  </Sections>
</AdminPageLayout>
